import { resolveAssetUrl } from "../../utils/assets";

export type ItemImage = {
  /** Resolved and ready for an `<img src>`. */
  url: string;
  /** The value as stored, kept so a thumbnail key can be derived from it (EB-518). */
  key: string;
};

type ImageSource = { picture?: string | null; images?: string[] };

/**
 * The images a product has, in display order, deduplicated.
 *
 * Extracted from `ListItemImages` in EB-537 so the carousel and the plain stacked list — still used
 * by the education detail page — cannot disagree about what a product's images are.
 */
export const collectItemImages = (item: ImageSource): ItemImage[] => {
  const stored: string[] = [];

  if (item.picture) stored.push(item.picture);
  if (Array.isArray(item.images)) stored.push(...item.images.filter(Boolean));

  // Deduplicate on the *resolved* URL, not the stored value (EB-514). Until EB-516 backfills the
  // table, the same file can be stored as an absolute S3 URL in `picture` and as a key in `images`;
  // both resolve to one URL, and deduplicating afterwards is what stops it rendering twice.
  const seen = new Set<string>();
  const images: ItemImage[] = [];

  for (const key of stored) {
    const url = resolveAssetUrl(key);
    if (!url || seen.has(url)) continue;
    seen.add(url);
    images.push({ url, key });
  }

  return images;
};
